import { loading_off, loading_on } from 'store/actionTypes'

const loadingReducer = (state: boolean = false, action) => {
    switch (action.type) {
        case loading_on:
            return action.payload.loading;
        case loading_off:
            return action.payload.loading;
        default:
            return state;
    }
}

export default loadingReducer;